"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Delete = _interopRequireDefault(require("@mui/icons-material/Delete"));
var _mui = require("tss-react/mui");
var _styles = require("@mui/material/styles");
var _CloudUpload = _interopRequireDefault(require("@mui/icons-material/CloudUpload"));
var _InsertPhoto = _interopRequireDefault(require("@mui/icons-material/InsertPhoto"));
var _InsertDriveFile = _interopRequireDefault(require("@mui/icons-material/InsertDriveFile"));
var _PictureAsPdf = _interopRequireDefault(require("@mui/icons-material/PictureAsPdf"));
var _Description = _interopRequireDefault(require("@mui/icons-material/Description"));
var _Audiotrack = _interopRequireDefault(require("@mui/icons-material/Audiotrack"));
var _Folder = _interopRequireDefault(require("@mui/icons-material/Folder"));
var _Album = _interopRequireDefault(require("@mui/icons-material/Album"));
var _Movie = _interopRequireDefault(require("@mui/icons-material/Movie"));
var _Gif = _interopRequireDefault(require("@mui/icons-material/Gif"));
var _reactDropzone = require("react-dropzone");
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var fileIcons = {
  jpg: _InsertPhoto["default"],
  jpeg: _InsertPhoto["default"],
  png: _InsertPhoto["default"],
  svg: _InsertPhoto["default"],
  tif: _InsertPhoto["default"],
  gif: _Gif["default"],
  doc: _Description["default"],
  docm: _Description["default"],
  docx: _Description["default"],
  dot: _Description["default"],
  odt: _Description["default"],
  txt: _Description["default"],
  pdf: _PictureAsPdf["default"],
  xlsx: _Description["default"],
  xls: _Description["default"],
  xlsm: _Description["default"],
  xltx: _Description["default"],
  xml: _Description["default"],
  pot: _InsertDriveFile["default"],
  pps: _InsertDriveFile["default"],
  mp4: _Movie["default"],
  mov: _Movie["default"],
  wmv: _Movie["default"],
  avi: _Movie["default"],
  flv: _Movie["default"],
  mkv: _Movie["default"],
  avchd: _Movie["default"],
  mp3: _Audiotrack["default"],
  wav: _Audiotrack["default"],
  ogg: _Audiotrack["default"],
  wma: _Audiotrack["default"],
  iso: _Album["default"],
  rar: _Folder["default"],
  zip: _Folder["default"]
};
var useStyles = (0, _mui.makeStyles)()(function (theme, _params, classes) {
  return {
    message: {
      fontWeight: 'bold',
      fontSize: 'inherit'
    },
    suggestedText: {
      marginRight: theme.spacing(1)
    },
    wrongImageText: _defineProperty({
      color: theme.palette.darkGrey.main,
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }, theme.breakpoints.down('sm'), {
      flexWrap: 'wrap'
    }),
    uploadIcon: {
      color: theme.palette.primary.light,
      cursor: 'pointer',
      fontSize: 48
    },
    uploadIconSmall: {
      color: theme.palette.primary.light,
      cursor: 'pointer',
      fontSize: 24,
      margin: theme.spacing(0, 2)
    },
    dropZone: _defineProperty({
      borderRadius: 9,
      border: '3px dashed',
      minHeight: 147,
      backgroundColor: (0, _styles.alpha)(theme.palette.lightGrey.light, 0.5),
      borderColor: (0, _styles.alpha)(theme.palette.lightGrey.dark, 0.5),
      textAlign: 'center',
      padding: theme.spacing(3),
      transition: 'background-color 0.5s, border-color 0.5s',
      '& button': {
        color: theme.palette.primary.light,
        cursor: 'pointer',
        border: 'none',
        background: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        padding: 0,
        '&:focus': {
          outline: 'none'
        }
      },
      '&:focus': {
        outline: 'none'
      }
    }, "&.".concat(classes.disabled), _defineProperty({
      color: theme.palette.darkGrey.light,
      borderColor: (0, _styles.alpha)(theme.palette.darkGrey.light, 0.5)
    }, "& button, & .".concat(classes.uploadIcon), {
      color: (0, _styles.alpha)(theme.palette.darkGrey.light, 0.5)
    })),
    dropZoneSmall: _defineProperty({
      borderRadius: 9,
      border: '3px dashed',
      backgroundColor: (0, _styles.alpha)(theme.palette.lightGrey.light, 0.5),
      borderColor: (0, _styles.alpha)(theme.palette.primary.light, 0.5),
      padding: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      transition: 'background-color 0.5s, border-color 0.5s',
      '& button': {
        color: theme.palette.primary.light,
        cursor: 'pointer',
        border: 'none',
        background: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        padding: 0,
        '&:focus': {
          outline: 'none'
        }
      },
      '&:focus': {
        outline: 'none'
      }
    }, "&.".concat(classes.disabled), _defineProperty({
      color: theme.palette.darkGrey.light,
      borderColor: (0, _styles.alpha)(theme.palette.darkGrey.light, 0.5)
    }, "& button, & .".concat(classes.uploadIcon), {
      color: (0, _styles.alpha)(theme.palette.darkGrey.light, 0.5)
    })),
    dragging: {
      backgroundColor: (0, _styles.alpha)(theme.palette.lightGrey.main, 0.8),
      borderColor: (0, _styles.alpha)(theme.palette.primary.light, 0.8)
    },
    disabled: {},
    uploaded: {
      backgroundColor: theme.palette.background["default"],
      color: theme.palette.darkGrey.main,
      boxShadow: theme.customShadows["default"],
      borderRadius: 5,
      margin: theme.spacing(1, 0),
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    fileName: {
      width: '100%',
      margin: theme.spacing(0, 2),
      overflow: 'hidden',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    fileNameContainer: {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    onlyName: {
      color: theme.palette.darkGrey.main,
      fontWeight: 'bold'
    },
    fileSize: _defineProperty({
      width: 100,
      marginRight: theme.spacing(5)
    }, theme.breakpoints.down('sm'), {
      width: 160,
      marginRight: theme.spacing(1)
    }),
    deleteIconColor: {
      color: theme.palette.red.main
    },
    removeIconButton: {
      padding: 0
    },
    fileError: {
      borderColor: theme.palette.red.main
    },
    customInputLayout: {
      padding: theme.spacing(1.5),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    iconContainer: {
      textAlign: 'center'
    }
  };
});
var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (!bytes) return '0 Bytes';
  var kilobyte = 1024;
  var decimal = decimals < 0 ? 0 : decimals;
  var extensions = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var size = Math.floor(Math.log(bytes) / Math.log(kilobyte));
  return "".concat(parseFloat((bytes / Math.pow(kilobyte, size)).toFixed(decimal)), " ").concat(extensions[size]);
};
var FileInput = function FileInput(_ref) {
  var id = _ref.id,
    handleChange = _ref.handleChange,
    info = _ref.info,
    files = _ref.value,
    disabled = _ref.disabled,
    accept = _ref.accept,
    multiple = _ref.multiple,
    type = _ref.type,
    variant = _ref.variant,
    withPreview = _ref.withPreview,
    error = _ref.error;
  var _useStyles = useStyles(),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var onDrop = (0, _react.useCallback)(function (acceptedFiles, rejectedFiles) {
    if (rejectedFiles !== null && rejectedFiles !== void 0 && rejectedFiles.length) console.error('Rejected:', rejectedFiles); // eslint-disable-line no-console
    if (acceptedFiles.length && multiple) handleChange([].concat(_toConsumableArray(files), _toConsumableArray(acceptedFiles)));else if (acceptedFiles.length) handleChange(_toConsumableArray(acceptedFiles));
  }, [files, handleChange]);
  var removeFile = (0, _react.useCallback)(function (index) {
    return function () {
      var newFiles = _toConsumableArray(files);
      newFiles.splice(index, 1);
      handleChange(newFiles);
    };
  }, [files, handleChange]);
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      disabled: disabled,
      accept: type === 'image' ? 'image/*' : accept,
      multiple: multiple,
      onDrop: onDrop
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive;
  var hasSelectedFiles = !!files && !!files.length;
  var fileImageWithPreview = !multiple && withPreview;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", _extends({
    "data-testid": "drop-zone"
  }, getRootProps({
    className: cx(variant === 'normal' && classes.dropZone, variant === 'small' && classes.dropZoneSmall, withPreview && classes.customInputLayout, isDragActive && classes.dragging, disabled && classes.disabled, error && classes.fileError)
  })), /*#__PURE__*/_react["default"].createElement("input", _extends({}, getInputProps(), {
    id: id
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.iconContainer
  }, type === 'image' ? /*#__PURE__*/_react["default"].createElement(_InsertPhoto["default"], {
    className: cx(variant === 'small' && classes.uploadIconSmall, variant === 'normal' && classes.uploadIcon)
  }) : /*#__PURE__*/_react["default"].createElement(_CloudUpload["default"], {
    className: cx(variant === 'small' && classes.uploadIconSmall, variant === 'normal' && classes.uploadIcon)
  })), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.message,
    variant: "body1"
  }, type !== 'image' && /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "buttons:dragFileOrExplore"
  }, "Drag your file or ", /*#__PURE__*/_react["default"].createElement("button", {
    type: "button"
  }, "explore")), type === 'image' && (!hasSelectedFiles || !fileImageWithPreview) && /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "buttons:dragImageOrExplore"
  }, "Drag your image or ", /*#__PURE__*/_react["default"].createElement("button", {
    type: "button"
  }, "explore"))), type === 'image' && fileImageWithPreview && hasSelectedFiles && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fileNameContainer
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.onlyName,
    variant: "caption"
  }, files[0].name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrongImageText
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    className: classes.suggestedText,
    component: "div"
  }, info), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "buttons:uploadWrongImage"
  }, "Uploaded the wrong image? ", /*#__PURE__*/_react["default"].createElement("button", {
    type: "button"
  }, "Edit here"))))), !hasSelectedFiles && info), hasSelectedFiles && !fileImageWithPreview && files.map(function (file, index) {
    var fileExtension = file.name.split('.').pop();
    var fileSize = formatBytes(file.size);
    var defaultIcon = 'pot';
    var Icon = fileIcons[fileExtension] || fileIcons[defaultIcon];
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.uploaded,
      key: "".concat(file.name).concat(file.lastModified)
    }, type === 'image' ? /*#__PURE__*/_react["default"].createElement(_InsertPhoto["default"], {
      color: "primary"
    }) : /*#__PURE__*/_react["default"].createElement(Icon, {
      color: "primary"
    }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: classes.fileName
    }, file.name), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      className: classes.fileSize
    }, fileSize), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      onClick: removeFile(index),
      size: "small",
      color: "inherit",
      "aria-label": "remove"
    }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
      fontSize: "inherit",
      className: classes.deleteIconColor
    })));
  }));
};
FileInput.propTypes = {
  id: _propTypes["default"].string,
  value: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(File)).isRequired,
  handleChange: _propTypes["default"].func.isRequired,
  info: _propTypes["default"].node,
  accept: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  multiple: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  type: _propTypes["default"].oneOf(['file', 'image']),
  variant: _propTypes["default"].oneOf(['normal', 'small']),
  withPreview: _propTypes["default"].bool,
  error: _propTypes["default"].string
};
FileInput.defaultProps = {
  multiple: false,
  accept: undefined,
  info: undefined,
  disabled: undefined,
  type: 'file',
  variant: 'normal',
  withPreview: false,
  id: 'fileInput',
  error: ''
};
var _default = (0, _withFormField["default"])({
  messagePosition: 'bottom'
})(FileInput);
exports["default"] = _default;